import { accountsRootReducers } from '@repo/accounts-store'
import { catalogsRootReducers } from '@repo/catalogs-store'
import { mailboxRootReducers } from '@repo/mailbox-store'
import { positionRootReducers } from '@repo/position-store'
import { toolsRootReducers } from '@repo/tools-store'
import { usersRootReducers } from '@repo/user-store'
import { appRootReducers } from '../reducers'

type RootReducers = typeof positionRootReducers &
  typeof accountsRootReducers &
  typeof toolsRootReducers &
  typeof usersRootReducers &
  typeof appRootReducers &
  typeof catalogsRootReducers &
  typeof mailboxRootReducers

export const rootReducers: RootReducers = {
  ...positionRootReducers,
  ...accountsRootReducers,
  ...toolsRootReducers,
  ...usersRootReducers,
  ...appRootReducers,
  ...catalogsRootReducers,
  ...mailboxRootReducers,
}
